<template>
  <div>
    <div class="ceiling">
      <home-top></home-top>
      <top-search :showHot="true" type="home"></top-search>
      <!-- 头部导航栏 -->
      <!--      <navicat :current="-1" height="80px" background="#fff"></navicat>-->
    </div>
    <!-- <div class="h-top"></div> -->
    <div class="content w-1400">
      <div class="bread-crumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/search-page' }">搜索</el-breadcrumb-item>
          <el-breadcrumb-item>{{ detailInfo.name }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!--      产品详情-->
      <div class="content-body-top">
        <!-- <img class="content-body-top-img" :src="detailInfo.image" alt="商品图片" /> -->
        <div class="content-right">
          <div class="top-btn">
            <div class="btn-left">
              <div class="btn-left-top-name">{{ detailInfo.name }}
                <el-tag size="mini" type="danger" v-if="detailInfo.is_danger==1">{{ '危化产品' }}</el-tag>
              </div>
            </div>
            <div class="btn-right">
              <el-button type="primary" @click="handleHistory" plain>历史报价</el-button>
            </div>
          </div>
          <div class="bottom-table">
            <table border="1" class="custom-table">
              <tr>
                <td colspan="2" rowspan="2" class="table-img-box">
                  <img class="content-body-top-img" :src="detailInfo.image" alt="商品图片"/>
                  <!-- <img class="content-body-top-img" src="../../static/index/demo/image.png" alt="商品图片" /> -->
                </td>
                <td class="english-name">cas</td>
                <td class="english-name-value">{{ detailInfo.cas_no || '' }}</td>
                <td class="english-name">英文名</td>
                <td class="english-name-value">{{ detailInfo.name_en }}</td>
              </tr>
              <tr>
                <td>中文别名</td>
                <td>{{ detailInfo.alias_name || "--" }}</td>
                <td>英文别名</td>
                <td>{{ detailInfo.alias_name_en || "--" }}</td>
              </tr>
              <tr>
                <td>外观</td>
                <td>{{ detailInfo.appearance || "--" }}</td>
                <td>分子式</td>
                <td>{{ detailInfo.fenzishi || "--" }}</td>
                <td>分子量</td>
                <td>{{ detailInfo.fenziliang || "--" }}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>


      <div class="content-body-bottom">
        <div class="classfily-box">
          <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
            <el-menu-item :index="item.index" v-for="item in tarBarList" :key="item.id">{{ item.name }}</el-menu-item>
          </el-menu>
        </div>
        <div class="classfily-body">
          <div class="inner-box" v-if="activeIndex == '1'">
            <div class="inner-box-title">我要发布询单</div>
            <div class="inner-box-content">
              <el-form :model="form" label-width="120px" :rules="rules" ref="form">
                <el-row>
                  <el-col :span="8">
                    <el-form-item label="CAS" prop="cas_no">
                      <el-input v-model="form.cas_no" placeholder="请输入"/>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8" class="select-box">
                    <el-form-item label="需求量" prop="unit">
                      <el-input v-model="form.number" placeholder="请输入">
                        <el-select v-model="form.unit" slot="append" placeholder="请选择">
                          <el-option v-for="item in invoiceTypeList" :key="item.id" :label="item.label"
                                     :value="item.label"></el-option>
                        </el-select>
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="发票类型" prop="invoice_type">
                      <el-select v-model="form.invoice_type" placeholder="请选择">
                        <el-option label="增值税专用发票（13%）" value="1"></el-option>
                        <el-option label="增值税普通发票" value="2"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <el-form-item label="收货地区" prop="district">
                      <el-cascader :options="areaOptions" v-model="form.district" :props="{ expandTrigger: 'hover' }"
                                   placeholder="请选择"/>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="期望价格" prop="expected_price">
                      <el-input v-model="form.expected_price" placeholder="请输入"/>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="询单有效期" prop="valid_day">
                      <el-select v-model="form.valid_day" placeholder="请选择">
                        <el-option
                            label="1天"
                            :value="1">
                        </el-option>
                        <el-option
                            label="3天"
                            :value="3">
                        </el-option>
                        <el-option
                            label="1周"
                            :value="7">
                        </el-option>
                        <el-option
                            label="1个月"
                            :value="30">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <el-form-item label="是否接受定制" prop="is_quotes">
                      <el-checkbox-group v-model="form.is_quotes">
                        <el-checkbox :label="1">无货时接受定制报价</el-checkbox>
                      </el-checkbox-group>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="备注">
                      <el-input v-model="form.remark" placeholder="请输入"/>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row class="btn-box">
                  <gradient-button width="214px" background="#387DF6" @hit="handleHit">立即询价</gradient-button>
                </el-row>
              </el-form>
            </div>
          </div>
          <div class="inner-box" v-if="activeIndex == '3'">
            <div class="inner-box-title">物理化学性质</div>
            <div class="inner-box-content">
              <div class="inner-box-content-item">
                <div v-html="detailInfo.properties"></div>
              </div>
              <el-empty v-if="!detailInfo.properties" description="暂无物理化学性质"/>
            </div>
          </div>
          <div class="inner-box" v-if="activeIndex == '4'">
            <div class="inner-box-title">生产用途</div>
            <div class="inner-box-content">
              <div class="inner-box-content-item">
                <div v-html="detailInfo.usag"></div>
              </div>
              <el-empty v-if="!detailInfo.usag" description="暂无生产用途"/>
            </div>
          </div>
          <div class="inner-box" v-if="activeIndex == '5'">
            <div class="inner-box-title">毒性和生态</div>
            <div class="inner-box-content">
              <div class="inner-box-content-item">
                <div v-html="detailInfo.toxicity_ecology"></div>
              </div>
              <el-empty v-if="!detailInfo.toxicity_ecology" description="暂无毒性和生态"/>
            </div>
          </div>
          <div class="inner-box" v-if="activeIndex == '6'">
            <div class="inner-box-title">安全信息</div>
            <div class="inner-box-content">
              <div class="inner-box-content-item">
                <div v-html="detailInfo.safe_information"></div>
              </div>
              <el-empty v-if="!detailInfo.safe_information" description="暂无安全信息"/>
            </div>
          </div>
          <div class="inner-box" v-if="activeIndex == '7'">
            <div class="inner-box-title">MSDS</div>
            <div class="inner-box-content">
              <div class="inner-box-content-item">
                <div v-html="detailInfo.MSDS"></div>
              </div>
              <el-empty v-if="!detailInfo.MSDS" description="暂无MSDS"/>
            </div>
          </div>
          <div class="inner-box" v-if="activeIndex == '8'">
            <div class="inner-box-title">上下游产品</div>
            <div class="inner-box-content">
              <div class="inner-box-content-item">
                <div v-html="detailInfo.up_product"></div>
              </div>
              <el-empty v-if="!detailInfo.up_product" description="暂无上下游产品"/>
            </div>
          </div>
          <div class="inner-box" v-if="activeIndex == '9'">
            <div class="inner-box-title">海关数据</div>
            <div class="inner-box-content">
              <div class="inner-box-content-item">
                <div v-html="detailInfo.customs_data"></div>
              </div>
              <el-empty v-if="!detailInfo.customs_data" description="暂无海关数据"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 历史报价弹窗 -->
    <history :historyDialog.sync="historyDialog" :detailInfo="detailInfo" @upDateState="handleHistoryClose"></history>
    <home-footer></home-footer>
  </div>
</template>
<script>
import {
  getDetail,
  getAreaOptions,
} from "@/api/modules/common";
import {quote_history, purchaseAdd} from "@/api/modules/user";
import homeTop from "../../components/public/home-top.vue";
import shopDefault from "../../components/goods/shop-default.vue";
import navicat from "../../components/navicat/navicat.vue";
import gradientButton from "@/components/button/gradient-button.vue";
import topSearch from "../../components/public/top-search.vue";
import HomeFooter from "../../components/public/home-footer.vue";
import history from "../../components/dialog/history.vue";
import {mapGetters} from "vuex";

export default {
  components: {HomeFooter, homeTop, shopDefault, navicat, gradientButton, topSearch, history},
  data() {
    return {
      historyDialog: false,
      id: this.$route.query.id,
      activeIndex: "1",
      detailInfo: {},
      form: {
        cas_no: "",
        unit: "",
        number: "",
        invoice_type: "",
        district: [],
        expected_price: "",
        remark: "",
        valid_day: "",
        is_quotes: "",
      },
      areaOptions: [],
      tarBarList: [
        {
          name: "我要发布询单",
          index: "1",
        },
        {
          name: "物理化学性质",
          index: "3",
        },
        {
          name: "生产用途",
          index: "4",
        },
        {
          name: "毒性和生态",
          index: "5",
        },
        {
          name: "安全信息",
          index: "6",
        },
        {
          name: "MSDS",
          index: "7",
        },
        {
          name: "上下游产品",
          index: "8",
        },
        {
          name: "海关数据",
          index: "9",
        },
      ],
      rules: {
        cas_no: [{required: true, message: "请输入CAS号", trigger: "blur"}],
        number: [{required: true, message: "请输入需求量", trigger: "blur"}],
        unit: [{required: true, message: "请选择单位", trigger: "change"}],
        invoice_type: [
          {required: true, message: "请选择发票类型", trigger: "blur"},
        ],
        district: [
          {required: true, message: "请选择收货地区", trigger: "blur"},
        ],
        expected_price: [{
          validator: (rule, value, callback) => {
            if (!value) {
              // 如果为空，则通过验证（非必填）
              callback();
            } else {
              const price = Number(value);
              if (isNaN(price)) {
                callback(new Error('请输入有效的数字'));
              } else if (price <= 0) {
                callback(new Error('期望价格必须大于0'));
              } else {
                callback();
              }
            }
          },
          trigger: 'blur'
        }],
        valid_day: [
          {required: true, message: "请选择询单有效期", trigger: "change"},
        ]
      },
      quoteList: [],
      total: 0,
      pageSize: 10,
      currentPage: 1,
    };
  },
  mounted() {
    this.getDetail();
    this.getInit();
  },
  computed: {
    ...mapGetters(["userInfo"]),
    invoiceTypeList() {
      return this.$store.state.config.unitList
    }
  },
  methods: {

    // 关闭历史报价弹窗
    handleHistoryClose(state) {
      this.historyDialog = state;
    },
    // 历史报价弹窗
    handleHistory() {
      this.historyDialog = true;
    },
    handleHit() {
      if (!this.mixCheckLogin()) {
        return
      }
      if (!this.mixCheckUserAudit()) {
        return
      }
      if (!this.form.is_quotes) {
        this.form.is_quotes = 2
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          purchaseAdd({info: [this.form]}).then((res) => {
            if (res.data.code == 10000) {
              this.$message.success({
                message: res.data.message,
                type: "success",
                duration: 2000,
                offset: 300,
              });
              setTimeout(() => {
                this.$refs.form.resetFields();
                this.$router.push({
                  path: "/user/purchase/post",
                });
              }, 2000);
            }
          });
        }
      });
    },
    handleSelect(key, keyPath) {
      this.activeIndex = key;
    },
    async getDetail() {
      let res = await getDetail(this.id);
      this.detailInfo = res.data.data;
      this.form.cas_no = this.detailInfo.cas_no
    },
    async getInit() {
      this.form.unit = this.invoiceTypeList[0].label
      let res2 = await getAreaOptions();
      this.areaOptions = res2.data.data.map((item) => {
        return {
          value: item.id,
          label: item.name,
          children: item.children.map((item) => {
            return {
              value: item.id,
              label: item.name,
              children: item.children.map((item) => {
                return {
                  value: item.id,
                  label: item.name,
                };
              }),
            };
          }),
        };
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.bread-crumb {
  padding: 20px 0;
  margin: 0;
}

.h-top {
  //height: 157px;
  //height: 95px;
  height: 185px;
}

.select-box {
  ::v-deep .el-select {
    width: 100px !important;
  }
}

::v-deep .el-cascader {
  width: 100%;
}

.content {
  .title-page {
    font-weight: 800;
    font-size: 24px;
    color: #00112b;
    padding: 30px 0;
  }

  .content-body-top {
    background: #ffffff;
    padding: 30px;
    box-sizing: border-box;
    display: flex;


    .content-right {
      flex: 1;

      .top-btn {
        display: flex;
        justify-content: space-between;

        .btn-left {
          .btn-left-top-name {
            font-weight: 800;
            font-size: 24px;
            color: #00112b;
          }

          .tag-box {
            padding: 0 8px;
            margin-top: 20px;
            height: 36px;
            border-radius: 3px 3px 3px 3px;
            border: 1px solid #afafaf;
            line-height: 36px;
            font-weight: 400;
            font-size: 18px;
            color: #333333;
            text-align: center;

            .color {
              color: #5f616c !important;
            }
          }
        }
      }

      .bottom-table {
        padding-top: 20px;
      }

      .custom-table {
        width: 100%;
        border-collapse: collapse;
        /* 关键：合并边框 */
        border-color: #f3f3f3;

        .table-img-box {
          background: #ffffff !important;

          .content-body-top-img {
            width: 200px;
            height: 200px;
            object-fit: contain;
          }
        }

        .english-name {
          background: #f9faff;
          text-align: center;
          color: #5f616c !important;
        }

        .english-name-value {
          background: #ffffff !important;
          text-align: left !important;
          padding: 0px 10px;
          border: 1px solid #f3f3f3;
          color: #00112b !important;
        }


        /* 新增样式规则 */
        td:nth-child(1),
        td:nth-child(3),
        td:nth-child(5) {
          white-space: nowrap;
          padding: 10px 20px;
          background: #f9faff;
          text-align: center;
          color: #5f616c;
        }

        td:nth-child(2),
        td:nth-child(4),
        td:nth-child(6) {
          // line-height: 60px;
          padding: 10px;
          border: 1px solid #f3f3f3;
          color: #00112b;
        }
      }
    }
  }

  .content-body-bottom {
    padding-top: 40px;
    margin-bottom: 40px;

    .classfily-box {
      background: #ffffff;
      padding: 0 100px;
      margin-bottom: 10px;
    }

    .classfily-body {
      background: #ffffff;

      .inner-box {
        padding: 20px;

        ::v-deep .el-select {
          width: 100%;
        }

        .inner-box-title {
          font-weight: bold;
          font-size: 20px;
          color: #00112b;
          padding-bottom: 20px;
          margin-left: 40px;
          margin-bottom: 20px;
          border-bottom: 1px solid #f5f5f5;

          // line-height: 68px;
        }

        .btn-box {
          display: flex;
          justify-content: flex-end;
        }
      }
    }
  }
}


</style>
